/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForDataBricks extends models.ServiceAccountNativeDetailsBaseForSaasDataServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForDataBricks");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForDataBricks.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForDataBricks>): ServiceAccountNativeDetailsForDataBricks {
        let obj = Object.assign(new ServiceAccountNativeDetailsForDataBricks(), model);
        ServiceAccountNativeDetailsForDataBricks.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForDataBricks>): ServiceAccountNativeDetailsForDataBricks {
        if (!model) return null;
        return ServiceAccountNativeDetailsForDataBricks.newInstance(<ServiceAccountNativeDetailsForDataBricks> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForDataBricks) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForDataBricks.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForDataBricks): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasDataServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForDataBricks.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
